(function (ws) {
    'use strict';
    ws.models.applyEndUserAccount = Backbone.Model.extend({
        defaults: {
            endUserAccount: '',
            sapEndUser: true //TRUE when end user applied from modal, FALSE when end user company input field value saved to BE
        },

        url: function () {
            return globals.path.api.quoting.applyEndUserAccount.replace('{quoteId}', this.get('quoteId'));
        }
    });
})(westcon);
